import initCrispChat from "@/external/crisp/crisp.js";
import { isPublicNoTrackingRoute } from "./publicNoTrackingRoute";

export const setupCrispChat = () => {
  if (isPublicNoTrackingRoute()) {
    return;
  }

  initCrispChat();
};
